import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { SelfAlertReason } from '../builders/self_alert_reason_builder';
import { ISelfAlertCourseDatasource } from '../datasources/self_alert_course_datasource';
import { ISelfAlertReasonDatasource } from '../datasources/self_alert_reasons_datasource';
import { SelfAlertTermModel } from '../models/self_alert_term_model';

export class SelfAlertDialogQuery implements IQuery {
  private _result: {
    reasons: SelfAlertReason[];
    enrollments: Array<Record<string, string>>;
  };

  constructor(
    private ngSelfAlertTermModel: SelfAlertTermModel,
    private ngSelfAlertCourseDatasource: ISelfAlertCourseDatasource,
    private ngSelfAlertReasonDatasource: ISelfAlertReasonDatasource
  ) {
    Query.registerQuery(this, ngSelfAlertTermModel, ngSelfAlertCourseDatasource, ngSelfAlertReasonDatasource);
  }

  run(): SelfAlertDialogQuery {
    const alertReasons: SelfAlertReason[] = _4.orderBy(this.ngSelfAlertReasonDatasource.values(), ['reason']);
    const courses = this.ngSelfAlertCourseDatasource.read();
    // sorting done by STC
    const enrollments = this.ngSelfAlertTermModel.read().enrollments;

    const comboboxInput: Array<Record<string, string>> = [];
    enrollments.forEach((el) => {
      comboboxInput.push({ title: `${el.term}`, heading: 'true' });
      el.courseIds.forEach((courseId) => {
        comboboxInput.push({ title: `${courses[courseId].courseName}`, value: `${courseId}` });
      });
    });

    this._result = {
      reasons: alertReasons,
      enrollments: comboboxInput
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-priority-feed').service('ngSelfAlertDialogQuery', SelfAlertDialogQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/queries/self_alert_dialog_query.ts